import React from 'react';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import {
  FDPaper, FDSelectInput, FDStack,
} from '@facet-wealth/design';
import { GuidedHouseholdReviewZoneDescriptions } from 'Components/UI/guidedHouseholdReview/zoneDescriptions';
import { RoadmapGoals } from 'Views/Page/Content/Templates/WizardTemplates/RoadmapDeliverable/GoalsByTimeStepTemplate/RoadmapGoals';
import useMobileLayout from 'Hooks/useMobileLayout';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { dataAttrs } from 'Helpers/Testing';

export const Content = () => {
  const { resource } = useMetaLayoutContext();
  const isMobile = useMobileLayout();
  const [goalFilter, setGoalFilter] = React.useState(resource.attr('goalsByTimeframe').resources().head().id());
  return (
    <FDPaper appearance={'flat'} width={'100%'}>
      <FDStack direction={'column'} paddingY={5} paddingX={isMobile ? 2 : 3} spacing={4}>
        <FDStack
          direction={isMobile ? 'column' : 'row'}
          spacing={isMobile ? 3 : 1}
          justifyContent={isMobile ? 'normal' : 'space-between'}
        >
          <FDStack direction={'column'} spacing={1}>
            <MetaControlField attr={'goalsTitle'} />
            <MetaControlField attr={'goalsSubtitle'} />
          </FDStack>
          <FDSelectInput
            options={
              resource.attr('goalsByTimeframe').resources().list()
                .map(option => ({
                  id: option.id(),
                  prompt: option.attr('name'),
                }))}
            onChange={(val) => {
              if (val === undefined) { // this check is needed in case of clear
                setGoalFilter(resource.attr('goalsByTimeframe').resources().head().id());
                return;
              }
              setGoalFilter(val);
            }}
            label={resource.meta().field('goalsByTimeframe').attr('prompt')}
            value={goalFilter}
            multiple={false}
            helperText={''}
            {...dataAttrs('timeframe-select')}
          />
        </FDStack>
        <GuidedHouseholdReviewZoneDescriptions resource={resource} />
        <RoadmapGoals
          goals={
            resource.attr('goalsByTimeframe').resources().list().find((timeframe) => timeframe.id() === goalFilter)
              .attr('goals')
              .resources()
              .list()
          }
          showDetails
          showTooltip
          showProgress={false}
        />
      </FDStack>
    </FDPaper>
  );
};
